import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3 6.75h18s1.5 0 1.5 1.5v13.5s0 1.5-1.5 1.5H3s-1.5 0-1.5-1.5V8.25s0-1.5 1.5-1.5"
    }, null, -1),
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m22.3 7.5-2.4-5.859A1.5 1.5 0 0 0 18.526.75H5.475a1.5 1.5 0 0 0-1.375.891L1.7 7.5M12 6.75v-6m2.25 18h4.5"
    }, null, -1)
  ]));
}
const shoppingShippingBoxParcelPackage = { render };
export {
  shoppingShippingBoxParcelPackage as default,
  render
};
//# sourceMappingURL=shopping-shipping-box-parcel-package.svg.js.map
